import React, { Component, Fragment } from 'react';
import classnames from 'classnames/bind';
import { bool, string } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './Selector.css';

const cx = classnames.bind(styles);

class Selector extends Component {
  static propTypes = {
    defaultChecked: bool,
    icon: string,
    text: string,
    label: string,
    doubleLine: bool,
    withBg: bool,
    disabled: bool,
    multi: bool,
    large: bool,
    bgImage: string
  };

  state = { isChecked: false };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.defaultChecked && !prevState.isChecked) {
      return { isChecked: true };
    }

    return null;
  }

  toggleChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  }

  /* eslint-disable react/display-name */
  renderInputContent = () => {
    const { text, icon, label, large, bgImage, disabled } = this.props;
    let svg;
    const textClasses = classnames(styles.innerText,
      {
        'large': (!icon || (large && icon)) && !bgImage,
        'hotspot-title': (large && !icon) && !bgImage
      }
    );
    const labelClasses = classnames(styles.comp, {'small': !large});

    if (bgImage) {
      svg = require(
        `assets/svgs/ccp/60/${bgImage}/${disabled ? 'Grey' : 'Color'}.svg`
      ); // TODO: should the fullPath be dynamic?
    }

    return (
      <Fragment>
        { icon ? <Icon icon={icon} type={'40'} /> : null }
        { bgImage
            ? <svg className={styles.image} width={60} height={60} >
                <use xlinkHref={`#${svg.default.id}`} fill={ '#333333' } />
              </svg>
            : null
        }
        { text ? <p className={textClasses}>{text}</p> : null }
        { label ? <p className={labelClasses}>{label}</p> : null }
      </Fragment>
    );
  }

  renderInput = () => {
    const { disabled, multi } = this.props;
    const { isChecked } = this.state;

    return (
      <Fragment>
        { this.renderInputContent() }
        <input
          className={styles.input}
          type={multi ? 'checkbox' : 'radio'}
          disabled={disabled}
          checked={isChecked}
          onChange={this.toggleChecked}
        />
      </Fragment>
    );
  }
  /* eslint-enable react/display-name */

  render() {
    const { icon, label, doubleLine, withBg, disabled, large, multi, bgImage } = this.props;
    const { isChecked } = this.state;
    const inputFieldClasses = cx(styles.inputField, {
      isSelected: isChecked,
      withLabel: label,
      withIcon: icon,
      double: doubleLine,
      isDisabled: disabled,
      withBg,
      large,
      multi,
      withImage: bgImage
    });

    return (
      <Fragment>
        <div className={inputFieldClasses} onClick={this.toggleChecked}>
          <div className={styles.inner}>
            { this.renderInput() }
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/Selector.js